// ugc 二期接口
import { api } from '../creat-api'

// 首页 ===> 汇总统计
export function getCollectData (params) {
  return api({
    url: '/collectData',
    params
  })
}

// 获取全国占比数据
export function playNationalProportion (params) {
  return api({
    url: '/playNationalProportion',
    params
  })
}

// 获取折线/趋势图数据
export function trendChartData (params) {
  return api({
    url: '/trendChartData',
    params
  })
}

// 数据中心 ===> 作品收益
export function programIncome (params) {
  return api({
    url: '/programIncome',
    params
  })
}

// 数据中心 ===> 作品收益导出
export function programIncomeExport (params) {
  return api({
    method: 'POST',
    url: '/programIncomeExport',
    data: params
  })
}

// 数据中心 ===> 专辑收益
export function programSetIncome (params) {
  return api({
    url: '/programSetIncome',
    params
  })
}

// 数据中心 ===> 专辑收益导出
export function programSetIncomeExport (params) {
  return api({
    method: 'POST',
    url: '/programSetIncomeExport',
    data: params
  })
}
